// extracted by mini-css-extract-plugin
export var graphic = "heroslider-module--graphic--7oGIx";
export var imageHolder = "heroslider-module--imageHolder--2mPjY";
export var overlay = "heroslider-module--overlay--3d84e";
export var section = "heroslider-module--section--2tkxo";
export var swiperHolder = "heroslider-module--swiperHolder--1n-ik";